<template>
    <div>
        <div class="row">
            <div class="col-12 ">
                <div class="card mb-3">
                    <div class="row no-gutters">
                        <div class="col-2">
                            <div class="card-body text-elev-blue">
                                <svg xmlns="http://www.w3.org/2000/svg" class="card-icon" viewBox="0 0 20 20"
                                    fill="currentColor">
                                    <path d="M9 2a1 1 0 000 2h2a1 1 0 100-2H9z" />
                                    <path fill-rule="evenodd"
                                        d="M4 5a2 2 0 012-2 3 3 0 003 3h2a3 3 0 003-3 2 2 0 012 2v11a2 2 0 01-2 2H6a2 2 0 01-2-2V5zm9.707 5.707a1 1 0 00-1.414-1.414L9 12.586l-1.293-1.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z"
                                        clip-rule="evenodd" />
                                </svg>
                            </div>
                        </div>
                        <div class="col-10">
                            <div class="card-body pb-0">
                                <h5 class="card-title text-xs">{{ $t('Teoriprøven') }}</h5>
                                <p class="text-2xl mb-0"><strong>{{ $t('Bestått teoriprøven?') }}</strong></p>
                            </div>
                            <div class="hr-wrapper">
                                <hr>
                            </div>
                            <div class="card-body pt-1">
                                <div class="btn btn-secondary btn-block" v-show="!showForm" @click="toggle">{{
                                    $t('Registrer beståttdato') }}</div>
                                <div v-show="showForm">
                                    <div class="text-sm">
                                        {{ $t('Jeg har bestått teoriprøven i {className}', { className: '' }) }}
                                        <span v-show="Object.keys(classlist).length > 1">
                                            <select class="form-select class-select-inline mb-2" v-model="classId">
                                                <option :value="i" v-for="(c, i) in classlist"
                                                    :selected="classId === i">
                                                    {{ c }}</option>
                                            </select>
                                        </span>
                                        <span v-show="Object.keys(classlist).length === 1">{{ className }}</span><span
                                            v-show="!forgotDate">,
                                            <span class="inline-datepicker">
                                                <VueDatePicker v-if="loaded" :min-date="minDate" :max-date="maxDate"
                                                    :format="dateFormat" :locale="locale" :auto-apply="true"
                                                    :placeholder="$t('Velg dato')" :enable-time-picker="false"
                                                    v-model="passedDate" :dark="darkModeActive">
                                                </VueDatePicker>
                                            </span>
                                        </span>
                                        <br>
                                        <span class="form-check my-2">
                                            <input class="form-check-input" type="checkbox" value="1"
                                                v-model="forgotDate" id="forgot-date">
                                            <label class="form-check-label" for="forgot-date">{{ $t('Jeg husker ikke datoen') }}</label>
                                        </span>
                                    </div>
                                    <div class="text-center">
                                        <button class="btn btn-success fw-bold btn-block px-4" @click="save"
                                            :disabled="saving || saved">
                                            {{ $t('Lagre') }}
                                            <span class="spinner-border spinner-border-sm" role="status"
                                                aria-hidden="true" v-show="saving"></span>
                                            <svg xmlns="http://www.w3.org/2000/svg" class="input-icon" fill="none"
                                                viewBox="0 0 24 24" stroke="currentColor" v-show="saved">
                                                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                                                    d="M5 13l4 4L19 7" />
                                            </svg>
                                        </button>

                                        <div class="alert alert-danger mt-2 text-sm" v-show="savingError">{{ savingError
                                            }}</div>
                                        <div class="alert alert-success mt-2 text-sm" v-show="savingSuccess"
                                            v-html="savingSuccess"></div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script setup>
import { ref, onMounted, computed } from 'vue'
import Api from '../../api/User'
import SurveyStore from '../../state/surveyStore'
import VueDatePicker from '@vuepic/vue-datepicker'

const props = defineProps(['classid', 'classname'])

const darkModeActive = computed(() => document.documentElement.getAttribute('data-bs-theme') === 'dark')

const loaded = ref(false)
const saving = ref(false)
const saved = ref(false)
const classId = ref(props.classid)
const className = ref(props.classname)
const showForm = ref(false)
const forgotDate = ref(false)
const passedDate = ref(null)
const maxDate = ref(null)
const minDate = ref(null)
const classlist = ref([])
const savingError = ref('')
const savingSuccess = ref('')
const feedbackTimeout = ref(null)
const hideComponent = ref(false)
const locale = ref(window.locale)

const dateFormat = computed(() => window.VueCalendarLang(locale.value).dateFormat)

const init = () => {
    Api.TheoryClasslist().then(res => {
        classlist.value = res.data.classlist
        maxDate.value = new Date(res.data.maxDate * 1000)
        minDate.value = new Date(res.data.minDate * 1000)
        loaded.value = true

        classId.value = Object.keys(classlist.value)[0]
        className.value = classlist.value[classId.value]
        forgotDate.value = false

        if (!Object.keys(classlist.value).length) {
            hideComponent.value = true
        }
    })
}

const toggle = () => {
    showForm.value = !showForm.value
}
const save = () => {
    if (saving.value) {
        return
    }

    if (passedDate.value === null && !forgotDate.value) {
        showAndClearFeedback({ success: false, message: $t('Du må velge en dato eller velge «Jeg husker ikke datoen»') })
        return
    }
    saving.value = true

    Api.SetTheoryPassed({
        'class_id': classId.value,
        'date': passedDate.value,
        'forgot_date': forgotDate.value
    }).then(res => {
        showAndClearFeedback(res)
    }).catch(() => {
        console.log('error')
        showAndClearFeedback()
    })
}

const showAndClearFeedback = (res) => {
    saving.value = false
    if (res && res.success) {
        saved.value = true
        savingSuccess.value = res.message
        if (res.loadSurvey) {
            SurveyStore.bootTheoryPassedSurvey()
        }
    } else {
        savingError.value = res && res.message ? res.message : $t('Det skjedde noe galt. Prøv igjen senere.')
    }

    if (feedbackTimeout.value) {
        clearTimeout(feedbackTimeout.value)
    }

    if (res.success) {
        return
    }

    feedbackTimeout.value = setTimeout(() => {
        savingError.value = ''
        savingSuccess.value = ''
        feedbackTimeout.value = null
        saved.value = false

        if (res.success) {
            init()
        }
    }, 5000)
}

onMounted(() => {
    init()
})
</script>

<style>
label {
    font-weight: normal !important;
}
</style>